<template>
  <div class='description-training-component'>
    <div class='description-container'>

      <div class="header-line"></div>

      <div class='description-title-container'>
        <img class='title-logo' :src='training.logo'/>
        <div class='title-name'>{{ training.name.toUpperCase() }}</div>
      </div>
      <div class='description-banner-container' v-if="!training.disabled" @click="openModal">
        <div class='description-banner'></div>
        <div class='description-banner-text'>PARTICIPER</div>
      </div>

      <div class='description-banner-price' v-if="!training.disabled">
        <div class="price-container">
          <span class="price">1600 €</span>
          <span class="mobile">
            HT par personne
          </span>
          <span class="desktop">
            HT / <br/> PERSONNE
          </span>
        </div>
        <div class="duration">
          2 jours
        </div>
      </div>

      <div class='title-border'></div>
      <div class='description-details-container'>
        <div class='detail-title'>DESCRIPTIF</div>
        <div class='detail-content' v-html="training.description.details"></div>
      </div>
      <div class='detail-border'></div>
      <div class='description-goals-container'>
        <div class='goal-title'>OBJECTIFS</div>
        <div class='goal-content' v-for='goal in training.description.goals' :key='goal.id'>
          <ul type='circle' class='goal-list'>
            <li class='goal-list-element'>{{ goal.content }}</li>
          </ul>
        </div>
      </div>
      <div class='goal-border'></div>
      <div class='description-needs-container'>
        <NeedTrainingComponent :title='need.title' :elements='need.items' :alignItems="need.alignItems" v-for='need in training.description.needs' :key='need.id'></NeedTrainingComponent>
      </div>
      <button class='description-button' @click='openDescription(training.name)'>PROGRAMME</button>
      <div v-if="false" class='description-footer'>
        <div class='description-time'>
          <img src='@/assets/hourglass.svg' class='icons-footer'/>
          <div class='details-footer'>{{ training.description.time }}</div>
        </div>
        <div class='description-price'>
          <img src='@/assets/money.svg' class='icons-footer'/>
          <div class='details-footer'>{{ training.description.price }}</div>
        </div>
        <div class='description-trainer'>
          <img src='@/assets/man man.svg' class='icons-footer'/>
          <div class='details-footer'>{{ training.description.trainer }}</div>
        </div>
      </div>
    </div>

    <ParticipateModal v-if='showModalComponent' :trainingId="training.id" @close="closeModal"/>
  </div>
</template>

<script>
import NeedTrainingComponent from './NeedTrainingComponent'
import ParticipateModal from '@/components/modals/participateModal'

export default {
  name: 'DescriptionTrainingComponent',

  components: {
    NeedTrainingComponent,
    ParticipateModal
  },

  props: ['training', 'showTrainings'],

  data () {
    return {
      showModalComponent: false
    }
  },

  methods: {
    openDescription (trainingName) {
      this.$router.push({ name: 'TrainingPage', params: { trainingName: trainingName, mode: 'program' } })
    },
    openModal () {
      this.showModalComponent = true
      document.body.style.overflow = 'hidden'
    },
    closeModal () {
      this.showModalComponent = false
      document.body.style.overflow = ''
    }
  }
}
</script>

<style lang='scss' scoped>
.description-banner-price {
  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute;
  border: 1px solid #b98a30;
  border-radius: 2px;

  margin: 28px;
  margin-top: 20px;

  padding: 6px;

  font-size: 14px;
  color: #494949;
  font-weight: 500;

  @include media(phone) {
    margin: 8px 12px;
    position: relative;
    left: 0;
    right: 0;

    flex-direction: row;
    line-height: 24px;
  }

  .price-container {
    padding: 0 6px;
    border-bottom: 1px solid #b98a30;
    padding: 0 18px;
    padding-bottom: 6px;
    margin-bottom: 6px;
    line-height: 20px;

    .price {
      font-weight: bold;
    }

    .mobile {
      display: none;
    }

    @include media(phone) {
      .mobile { display: block; margin-left: 2px; }
      .desktop { display: none; }

      display: flex;

      padding-bottom: 0;
      margin-bottom: 0;

      border-bottom: none;
      border-right: 1px solid #b98a30;

      flex-shrink: 0;
    }
  }

  .duration {
    font-size: 16px;

    @include media(phone) {
      font-size: 14px;
      width: 100%;
      text-align: center;
    }
  }
}

.header-line {
  $size: 250px;
  position: absolute;
  height: 3px;
  width: $size;
  background: #b98a30;
  top: 0;
  left: calc(50% - (#{$size} / 2));

  @include media(phone) {
    width: 164px;
    left: calc(50% - (164px / 2));
  }
}
.description-training-component {
  max-width: 864px;
  width: 100%;
  right: 0;

  height: 1200px;
  position: relative;

  @include media(tablet) {
    height: unset;
  }

  .description-container {
    position: relative;

    box-sizing: border-box;

    display: grid;
    grid-template-columns: 12% 1fr 12%;
    height: 100%;
    width: 100%;

    @include media (phone) {
      display: block;
      height: auto;
    }

    .description-title-container {
      display: block;
      grid-column: 2;
      text-align: center;
      padding-top: 25px;
      margin: 0px auto;
      max-height: 100px;
      min-height: 100px;
      min-width: 350px;
      max-width: 350px;

      @include media (phone) {
        max-height: unset;
        min-height: unset;
        min-width: 200px;
        max-width: 200px;
      }

      .title-logo {
        max-width: 60px;
        max-height: 60px;
        min-height: 60px;
        min-width: 60px;

        @include media (phone) {
          width: 44px;
          height: 44px;
          min-height: unset;
          min-width: unset;
        }
      }

      .title-name {
        color: #494949;
        font-size: 2.5rem;
        font-weight: 900;
        letter-spacing: -0.03px;
        padding-top: 15px;
        max-width: 350px;
        max-height: 60px;
        min-height: 60px;
        min-width: 350px;

        @include media (phone) {
          font-size: 1.8rem;
          padding-top: 8px;
          max-width: 200px;
          max-height: unset;
          min-height: unset;
          min-width: 200px;

          height: 38px;
        }
      }
    }

    .description-banner-container {
      display: flex;
      position: absolute;

      max-height: 40px;
      height: 100%;
      width: 112px;

      top: 80px;
      right: -11px;

      align-self: flex-end;
      background-color: #B98A30;

      border-bottom-left-radius:100px;
      border-top-left-radius: 100px;

      box-shadow: 0 2px 6px 0 rgba(142,142,142,0.5);
      justify-content: center;

      margin-bottom: 20px;

      transition: all 0.3s ease;
      cursor: pointer;
      user-select: none;

      &:hover {
        background-color: lighten($color: #B98A30, $amount: 5)
      }

      @include media (phone) {
        top: 54px;
        width: 81px;
        height: 30px;

        right: -9px;
      }

      .description-banner {
        background-color: #8d6a2e;
        -webkit-clip-path: polygon(0 0, 0 100%, 100% 100%);
        clip-path: polygon(0 0, 0 100%, 100% 100%);
        height: 21%;
        position: absolute;
        top: -8px;
        right: -1px;
        width: 7%;

        @include media (phone) {
          top: -6px;
          right: 0px;
        }
      }

      .description-banner-text {
        align-self: center;
        color: #FFFFFF;
        font-size: 0.8rem;
        font-weight: 900;

        @include media (phone) {
          font-size: 0.6rem;
        }
      }
    }

    .title-border {
      align-self: flex-start;
      border-bottom: 1px solid #aaa3;
      grid-column: 2;
      justify-self: center;
      width: 35%;

      height: 42px;

      @include media (phone) {
        display: none;
      }
    }

    .description-details-container {
      grid-column: 2;

      @include media (phone) {
        margin-left: 25px;
        margin-right: 25px;
        margin-bottom: 25px;
        margin-top: 15px;
      }

      .detail-title {
        display: block;
        font-size: 1.1rem;
        font-weight: 900;
        letter-spacing: -0.08px;
        line-height: 32px;
        padding-bottom: 10px;
        text-align: center;
        color: #494949;

        @include media (phone) {
          padding-top: 10px;
          font-size: 1.1rem;
        }
      }

      .detail-content {
        display: block;
        font-size: 1rem;
        font-weight: 300;
        letter-spacing: -0.05px;
        text-align: justify;
        margin-bottom: 12px;

        line-height: 24px;

        @include media (phone) {
          text-align: left;
        }
      }
    }

    .detail-border {
      border-bottom: 1px solid #aaa3;
      grid-column: 2;
      justify-self: center;
      width: 35%;
      align-self: flex-start;

      @include media (phone) {
        width: 122px;
        margin: 0px auto;
      }
    }

    .description-goals-container {
      display: block;
      grid-column: 2;

      @include media (phone) {
        margin: 25px;
        margin-top: 15px;
      }

      .goal-title {
        font-size: 1.1rem;
        font-weight: 900;
        letter-spacing: -0.08px;
        line-height: 32px;
        padding-bottom: 10px;
        text-align: center;
        color: #494949;

        @include media (phone) {
          font-size: 1.1rem;
          padding-top: 10px;
        }
      }

      .goal-content {
        line-height: 24px;
        padding-left: 20px;

        .goal-list {
          font-size: 1rem;
          font-weight: 300;
          letter-spacing: -0.05px;
        }
      }
    }

    .goal-border {
      border-bottom: 1px solid #aaa3;
      grid-column: 2;
      justify-self: center;
      width: 35%;
      position: relative;
      align-self: flex-start;

      @include media (phone) {
        margin: 0px auto;
        width: 122px;
        margin-bottom: 25px;
      }
    }

    .description-needs-container {
      align-content: center;
      color: #494949;
      display: grid;
      grid-column: 2;
      grid-template-columns: 50% 50%;
      grid-template-rows: 50% 50%;
      justify-content: center;
      justify-items: center;
      width: 100%;

      @include media (tablet) {
        padding-bottom: 30px;
        display: unset;
        >div{
          width:80%;
          margin: 0 auto;
          border-top: none !important;
          border-right: none !important;
          border-left: none !important;
        }
        div:last-child {
          margin-bottom: 24px;
          border-bottom: none;
        }
        div:nth-child(1) {
          border-bottom: none !important;
        }

      }

      div:nth-child(1) {
        border-bottom: 1px solid #aaa3;
        border-right: 1px solid #aaa3;
      }

      div:nth-child(4) {
        border-left: 1px solid #aaa3;
        border-top: 1px solid #aaa3;

      }

    }

    .description-button {
      @extend %default-button;
      align-self: center;
      justify-self: center ;
      grid-column: 2;

      margin: 24px auto;
      margin-bottom: 48px;
    }

    .description-footer {
      align-self: flex-end;
      background-color: #F7F7F7;
      box-shadow: 0 -1px 7px 0 rgba(170,170,170,0.5);
      display: grid;
      grid-column: 1/4;
      grid-template-columns: 33% 33% 33%;
      grid-template-rows: 1;
      justify-content: space-between;
      padding: 10px 12%;
      max-height: 30px;
      height: 100%;
      bottom: 0px;

      @include media(tablet) {
        padding: 10px 0;
      }

      .description-item {
        align-items: center;
        display: flex;
        justify-content: center;

        .icons-footer {
          padding-right: 10px;
          width: 8%;
        }

        .details-footer {
          font-size: 0.7rem;
          font-weight: 900;
        }
      }

      .description-time {
        @extend .description-item;

        .icons-footer {
          width: 18px;

          @include media(tablet) {
            width: 9px;
          }
        }
      }

      .description-price {
        @extend .description-item;

        .icons-footer {
          width: 15%;
        }
      }

      .description-trainer {
        @extend .description-item;
      }
    }
  }

  .modal {
    border: 5px solid #B98A30;
    height: 900px;
    width: 612px;

    @include media(phone) {
      margin-top: 66px;
      width: 400px;
      height: auto;
    }

    .modal-title {
      color: #979797;
      font-size: 1.8rem;
      font-weight: 900;
      letter-spacing: 3.03px;
      text-align: left;
      padding-left: 15%;
      padding-top: 30px;

      @include media (phone) {
        font-size: 1.6rem;
        padding-left: 12%;
        padding-top: 20px;
      }
    }

    .modal-underline {
      border-bottom: 4px solid #979797;
      padding-bottom: 10px;
      margin-left: 15%;
      width: 10%;

      @include media (phone) {
        margin-left: 12%;
      }
    }

    .modal-button {
      background-color: #FFF;
      border: none;
      color: #B98A30;
      font-size: 1.7rem;
      font-weight: 900;
      position: relative;
      top: -50px;
      right: -280px;

      @include media (phone) {
        right: -180px;
        top: -60px;
      }
    }

    .contact-component {
      height: auto;

      @include media (phone) {
        height: auto;
      }

      @include media (tablet) {
        height: auto;
      }
    }
  }
}
</style>
